import type { ConnectedIdentity, ProviderId, ProviderView } from '../../api/apiSchemas';
import { getPresentation } from '../../auth/providerPresentation';
import { formatDate } from '../../lib/formatters';
import { Button } from '../ui';
import './account.css';

export type ConnectionCardProps =
  | {
      kind: 'linked';
      identity: ConnectedIdentity;
      busy: boolean;
      onUnlink: (provider: ProviderId) => void;
    }
  | {
      kind: 'available';
      provider: ProviderView;
      busy: boolean;
      onLink: (provider: ProviderId) => void;
    };

function unlinkDisabledHint(reason: ConnectedIdentity['unlinkDisabledReason']): string {
  if (reason === 'LAST_AUTH_METHOD') {
    return 'Đây là phương thức đăng nhập cuối cùng. Hãy liên kết thêm một phương thức khác trước.';
  }
  if (reason === 'POLICY') return 'Không thể gỡ liên kết theo chính sách hiện tại.';
  return '';
}

function BrandMark({ src }: { src: string }) {
  return (
    <span className="brandmark">
      <img src={src} alt="" aria-hidden="true" />
    </span>
  );
}

export function ConnectionCard(props: ConnectionCardProps) {
  if (props.kind === 'linked') {
    const { identity, busy, onUnlink } = props;
    const presentation = getPresentation(identity.provider);
    const hint = identity.canUnlink ? '' : unlinkDisabledHint(identity.unlinkDisabledReason);
    const meta = `Đã liên kết ngày ${formatDate(identity.linkedAt)}${
      identity.emailMasked ? ` · ${identity.emailMasked}` : ''
    }`;
    return (
      <div className="connection-card connection-card--linked">
        <div className="connection-card__main">
          <BrandMark src={presentation.iconAsset} />
          <div className="connection-card__body">
            <span className="connection-card__name">
              {presentation.displayName}
              <span className="pill pill--sm pill--linked">Đã liên kết</span>
            </span>
            <span className="connection-card__meta">{meta}</span>
            {hint ? <span className="connection-card__warn">{hint}</span> : null}
          </div>
        </div>
        <Button
          variant="secondary"
          disabled={!identity.canUnlink || busy}
          onClick={() => onUnlink(identity.provider)}
        >
          Gỡ liên kết
        </Button>
      </div>
    );
  }

  const { provider, busy, onLink } = props;
  const presentation = getPresentation(provider.id);
  return (
    <div className="connection-card connection-card--available">
      <div className="connection-card__main">
        <BrandMark src={presentation.iconAsset} />
        <span className="connection-card__name">{presentation.displayName}</span>
      </div>
      <Button variant="primary" loading={busy} disabled={busy} onClick={() => onLink(provider.id)}>
        {presentation.linkLabel}
      </Button>
    </div>
  );
}
